import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { Maps } from 'eemovel-map-library';

import {
  changeSearch,
  searchAddressOnMap,
  setIsActive,
  setMapCenter,
} from '../dashboard/redux/dashboardActions';
import useMapBounds from '../mapSearch/hooks/useMapBounds';
import { IMapOptions } from 'eemovel-map-library/src/data/google-maps/map.types';

function DashboardMap() {
  const dispatch = useDispatch();
  const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY as string;

  const { pin } = useSelector((state: any) => state.dashboardState);
  const { selectedCity } = useSelector((state: any) => state.mapSearch);
  const {
    user,
    profileRules: { hasAccessGeneralMarkets },
  } = useSelector((state: any) => state.layoutState);

  const [addressSelected, setAddressSelected] = useState(
    {} as google.maps.places.PlaceResult
  );
  const [mapOptions, setMapOptions] = useState<IMapOptions | undefined>(
    undefined
  );

  const getAddressInfo = () => {
    dispatch([
      searchAddressOnMap({ ...addressSelected }, pin),
      setIsActive({ name: 'results', value: true }),
      changeSearch({
        name: 'address',
        value: `${addressSelected.name}, Brasil`,
      }),
      changeSearch({
        name: 'addressFull',
        value: {
          address_components: addressSelected.address_components,
          formatted_address: addressSelected.formatted_address,
          geometry: addressSelected.geometry,
          place_id: addressSelected.place_id,
          plus_code: addressSelected.plus_code,
          types: addressSelected.types,
        },
      }),
      changeSearch({ name: 'isFetched', value: true }),
      setIsActive({ name: 'mapAction', value: '' }),
    ]);
  };

  useEffect(() => {
    if (addressSelected.address_components) getAddressInfo();
  }, [addressSelected]);

  const handleSelectAddress = (info: google.maps.places.PlaceResult) =>
    setAddressSelected(info);

  const bounds = useMapBounds();

  useEffect(() => {
    if (selectedCity) {
      setMapOptions({
        center: {
          lat: selectedCity.coordinates.latitude,
          lng: selectedCity.coordinates.longitude,
        },
      });
    }
  }, [selectedCity]);

  useEffect(() => {
    if (!user) {
      setMapOptions({});
    }
    if (!hasAccessGeneralMarkets && user && user.start_coordinate) {
      setMapCenter(user);
    }
  }, [user]);

  return !!mapOptions ? (
    <Maps
      GOOGLE_MAP_KEY={GOOGLE_MAP_KEY}
      inputId="input-searchbox"
      handleSelectAddress={handleSelectAddress}
      bounds={bounds}
      mapOptions={mapOptions}
    />
  ) : null;
}

export default DashboardMap;
